import { BsFillTelephoneFill } from "react-icons/bs";

export default function ContactUsInfo(){
return(
    <div className="text-center mt-auto mx-auto contact-info py-5 bg-cover bg-center" style={{ backgroundImage: 'url(assets/contact-bg.jpg)' }}>
    <p className="g-book text-uppercase text-white mb-2">The Majestic Hotel</p>
      <h1 className="heading-fonts text-uppercase text-3xl md:text-6xl text-white mb-0">Contact us</h1>
      <div className="border-b border-white w-3/4 mx-auto my-2 my-md-4"></div>
      <h4 className="text-[#f6d284] md:text-xl g-book text-uppercase mb-2 mb-md-4 mt-0">Reservations</h4>
      <div className="address hidden md:block">
        <p className="g-book md:text-xl text-white mb-2">
          <span className="text-[#f6d284]"> T:</span> +441323 730311
        </p>
        <p className="g-book md:text-xl text-white mb-0">
          <span className="text-[#f6d284] ms-2">E:</span> reservations@baymajestic.com
          <span className="text-[#f6d284] ms-2 mb-0">FB: </span><a href="https://www.facebook.com/majestichotel/" target="_blank" rel="noopener noreferrer" className="text-white">www.facebook.com/majestichotel</a>
          <span className="text-[#f6d284] ms-2 mb-0">IG: </span><a href="https://www.instagram.com/majestichotel" target="_blank" rel="noopener noreferrer" className="text-white">www.instagram.com/majestichotel</a>
        </p>
        <p className="g-book md:text-xl text-center text-white mt-0 mt-md-5 pt-1">26-34 Royal Parade, Eastbourne, BN22 7AN, United Kingdom</p>
      </div>
      <div className="address md:hidden text-left p-3">
        <p className="g-book md:text-xl text-white mb-0">
          <span className="text-brand-600">T:</span> +441323 730311
        </p>
        <p className="g-book md:text-xl text-white mb-0">
          <span className="text-brand-600">E:</span> reservations@baymajestic.com 
        </p>
        <p className="g-book md:text-xl text-white mb-0">
          <span className="text-brand-600 mb-0">FB: </span>
          <a href="https://www.facebook.com/majestichotel/" target="_blank" rel="noopener noreferrer" className="text-white">www.facebook.com/majestichotel</a>
        </p>
        <p>       
           <span className="text-[#f6d284]  mb-0">IG: </span><a href="https://www.instagram.com/majestichotel" target="_blank" rel="noopener noreferrer" className="text-white">www.instagram.com/majestichotel</a>
        </p>

        <p className="g-book md:text-xl text-left text-md-center text-white mt-0 mt-md-5 pt-1">26-34 Royal Parade, Eastbourne, BN22 7AN, United Kingdom</p>
      </div>
    </div>
)
}